import { render, staticRenderFns } from "./popular.vue?vue&type=template&id=7d0d96eb"
import script from "./popular.vue?vue&type=script&lang=ts"
export * from "./popular.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports